import BusinessCenterCompaniesPageView from "./BusinessCenterCompaniesPageView";

function BusinessCenterCompaniesPage() {
  return <BusinessCenterCompaniesPageView />;
}

export default BusinessCenterCompaniesPage;
